module.exports = __webpack_public_path__ + "static/note-importance-do-5f55910328e7b1929e8999953e2e3ccd.png";